import { render, staticRenderFns } from "./PolicyProductLink.vue?vue&type=template&id=5377054e"
import script from "./PolicyProductLink.vue?vue&type=script&lang=ts"
export * from "./PolicyProductLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports